import { createAction } from "@ngrx/store";

export const recentAnnouncementsInitialized = createAction(
  "[Recent Announcements]: Initialized",
);
